export class Form {
  formId?: any;
  name: string;

  constructor() {
    this.name = "";
  }
}
